export const CustomCurrencyFormat = (number: number, currency: string) =>  {
        const parts = number.toFixed(2).split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Separador de miles con puntos
        const decimalPart = parts[1]; // Decimales
        return `${integerPart},${decimalPart} ${currency}`;
    }